import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "15.3",
      height: "13.3",
      x: "4.35",
      y: "5.35",
      stroke: "currentColor",
      "stroke-width": "1.75",
      rx: "2.6"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "9.05",
      cy: "9.5",
      r: "1.1",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.75",
      d: "m6.9 15.2 2.8-2.8 2.3 2.1 2.1-2.2 2.95 2.9"
    }, null, -1)
  ]))]))
}
export default { render: render }